<h2 class="text-primary-dark text-[20px] font-semibold pb-1">
  {{ label | translate }}
</h2>